$ ->

  MPP.Modal.openOnClick '.mpp-container .show-all-photos-holder', '#photo-tiled-layout-modal'

  # Photo Viewer
  photoCarouselInit = false
  carouselModal = $ '#photo-carousel-modal'
  carousel = carouselModal.find '.jcarousel'
  photosTiledLayout = $ '#photos-tiled-layout'
  carouselNext = carouselModal.find '.carousel-next'
  carouselPrev = carouselModal.find '.carousel-previous'
  currentPhotoIndexSpan = carouselModal.find 'span.current-photo-index'
  totalNumPhotosSpan = carouselModal.find 'span.total-num-photos'
  totalNumPhotos = parseInt totalNumPhotosSpan.html()

  if photosTiledLayout.length
    thumbnails = photosTiledLayout.find 'li'
    thumbnails.click (e) ->
      thumbnailIndex = parseInt $(this).data('index')
      MPP.Modal.open '#photo-carousel-modal'

      if not photoCarouselInit
        createPhotoCarousel()
        photoCarouselInit = true

      carousel.jcarousel 'scroll', thumbnailIndex - 1, false
      currentPhotoIndexSpan.html thumbnailIndex
      decideArrowsAction(thumbnailIndex, totalNumPhotos)

  if carousel.length
    $('li.photo-thumb').click (e) ->

      if not photoCarouselInit
        carouselInstance = createPhotoCarousel()
        photoCarouselInit = true

      index = parseInt $(this).data("index")
      ## 0-based for transitions
      carousel.jcarousel 'scroll', index - 1, false

      currentPhotoIndexSpan.html index
      decideArrowsAction(index, totalNumPhotos)

  createPhotoCarousel = ->
    carousel.jcarousel()

    carouselNext.click (e) ->
      currentIndex = carousel.jcarousel("visible").data("index")
      newIndex = currentIndex + 1
      return if currentIndex == totalNumPhotos

      ## 0-based for transitions
      carousel.jcarousel 'scroll', newIndex - 1, postAnimation

    carouselPrev.click (e) ->
      currentIndex = carousel.jcarousel("visible").data("index")
      newIndex = currentIndex - 1
      return if currentIndex == 1

      ## 0-based for transitions
      carousel.jcarousel 'scroll', newIndex - 1, postAnimation

    adjustItemsWidth()
    $(window).resize ->
      return unless carouselModal.hasClass 'show-modal'
      adjustItemsWidth()

  adjustItemsWidth = ->
    width = carousel.innerWidth()
    carousel.find('li').css 'width', "#{width}px"

  postAnimation = ->
    transitionedIndex = carousel.jcarousel("visible").data("index")
    currentPhotoIndexSpan.html(transitionedIndex)
    decideArrowsAction(transitionedIndex, totalNumPhotos)

  decideArrowsAction = (currentIndex, totalNumPhotos) ->

    if currentIndex is 1
      carouselPrev.addClass 'disabled'
    else
      carouselPrev.removeClass 'disabled'

    if currentIndex is totalNumPhotos
      carouselNext.addClass 'disabled'
    else
      carouselNext.removeClass 'disabled'

  setImageMaxHeight = ->
    # we set the height to the max possible, giving enough space for the modal title and margins
    maxHeight = $(window).height() - 180
    carouselModal.find('.jcarousel ul li img').css 'max-height', maxHeight

  $('body').on 'modal-open:photo-carousel-modal', setImageMaxHeight

delayLoading = ->
  $('img.img-load-delay').each ->
    $imagex = $ this
    imgOriginal = $imagex.data 'original'
    $imagex.attr 'src', imgOriginal
    $imagex.addClass 'loaded'

  heroImage = $('.merchant-hero-image').css 'background-image'
  $('.tour-img').css('background-image', heroImage) if heroImage?

# Given that we're loading 900px+ images as 66px thumbnails without resizing, we're loading them after everything else is ready
# This is valid only for some images that are not in the Image Service
$(window).load delayLoading
